<section id="input-tags">
  @if (ticketSrv.tags.length == 0) {
    <div id="no-tag" (click)="openInput()" >
      <ion-icon name="fa-tag"></ion-icon>
      Tags hinzufügen...
    </div>
  }
  <div id="tags">
    @for (tag of ticketSrv.tags; track tag) {
      <div class="tag" [ngStyle]="{'background': tag.rgba, 'color': tag.hex}">
        {{tag.description}}
        @if (!platform.is('capacitor')) {
          <ion-icon name="fa-x-mark" (click)="deleteTag(tag)"></ion-icon>
        }
      </div>
    }
    @if (ticketSrv.tags.length > 0) {
      <div class="tag add" (click)="openInput()">
        @if (!platform.is('capacitor')) {
          <ion-icon name="fa-plus"></ion-icon>
        }
        @if (platform.is('capacitor')) {
          <ion-icon name="fa-pen"></ion-icon>
        }
      </div>
    }
  </div>
  <input #tagsearch type="text" placeholder="Tag hinzufügen..." [(ngModel)]="searchText" (ngModelChange)="search()" [class.open]="isInputOpen" (blur)="inputBlured()" (keydown.escape)="inputBlured()">
  <div id="tag-results" ArrowKeyUseable [arrowKeysOptions]="arrowKeysOptions" [class.open]="isInputOpen" >

    @if(showCreateTagButton) {
      <ion-item id="create-tag" (click)="createTagBySearchText()">
        <div class="tag">"{{searchText}}" als Tag hinzufügen...</div>
      </ion-item>
    }

    @for (tag of selectTags; track tag; let i = $index) {
      <ion-item [ngStyle]="{'--background': tag.rgba, '--color': tag.hex}" [class.active]="this.arrowKeysOptions.selectedItem == i" (mouseenter)="arrowKeysOptions.mouseOverItem.next(i)" (mousemove)="arrowKeysOptions.mouseMove.next(true)" (click)="addTag(i)">
        <div class="tag">{{tag?.description}}</div>
      </ion-item>
    }
  </div>
</section>